
import {
  invokeShopifyQuery,
  itemFilterWithActive,
  CARD,
} from "@/utils/shopify";
import processDateAvailable from "~/mixin/process-date-available-mixin";
import ProductMapMixin from "~/mixin/product-map-mixin";
import DeliveryWeekMixin from "~/mixin/delivery-week-mixin";
import FormatMixin from "~/mixin/format-mixin";
import { getDateSuffix } from "~/utils/locale";
import { butter } from "~/plugins/buttercms";
import  calCardMessageGenerator from "~/components/cal-card-message-generator.vue"

export default {
  name: "cal-sub6-card-message",
  components:{calCardMessageGenerator},
  mixins: [
    processDateAvailable,
    ProductMapMixin,
    DeliveryWeekMixin,
    FormatMixin,
  ],
  data() {
    return {
      cards: [] as any[],
      exclusiveCards: [] as any[],
      selectedCard: { ...this.$store.state.cartItem.card },
      messageWriteWindow: false,
      msgTemplates: [
        {
          message: "",
          title: "",
        },
      ],
      msgWriteWindowHeader: "",
      selectedMsgTemplates: [] as any,
      cardMessages:
        { ...this.$store.state.cartItem.cardMessages } || (new Object() as any),
      msgMaxCharacters: 900,
      remainingMsgCharacters: [] as number[],
      msgsMaxCharSet: [],
      isAiMessageLoading:false,
    };
  },
  computed: {
    subscriptionDeliveryDates() {
      return this.$store.state.cartItem.subscriptionDates
    },
  },
  props: {
    workflow: {
      type: String,
      required: false,
    },
    config: {
      type: Object,
      required: false,
    },
    subscriptionTimePeriod: {
      type: Number,
      required: false,
      default: 0,

    },
  },
  async  created() {
    await this.loadCards()

    if (this.workflow == 'SUBSCRIPTION') {
      this.$nuxt.$emit("disableContinueSubs", true);
    } else {
      this.$nuxt.$emit("disableContinue", true);
    }

    this.$nuxt.$on("scrollToSub6CardMessage", () => {
      const Sub6CardMessageEl = document.getElementById('sub6-card-message');
      if (Sub6CardMessageEl) {
        Sub6CardMessageEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });

    if (
      this.subscriptionTimePeriod &&
      JSON.stringify(this.cardMessages) === "{}"
    ) {
      for (let i = 0; i < this.subscriptionTimePeriod; i++) {
        this.cardMessages[this.getMessageKeyName(i)] = "";
        this.remainingMsgChars(i, 0);
      }
    } else if (JSON.stringify(this.cardMessages) === "{}") {
      this.cardMessages = { Message: "" };
      this.remainingMsgChars(0, 0);
    }

    // set card messages remaining chars
    if (JSON.stringify(this.cardMessages) !== "{}") {
      Object.entries(this.cardMessages).forEach(
        ([key, value]: any, index: number) => {
          this.remainingMsgChars(index, value.length);
        }
      );
    }

    if (Object.keys(this.selectedCard).length !== 0) {
      this.messageWriteWindow = true;
    }

    this.messageValidation();
  },
  methods: {
    getCardMessage(generatedMessage:any ){
       this.handleMessage(generatedMessage, 0);
      },
    cardMessageLoading(isCardMessageLoading:boolean){
       this.isAiMessageLoading=isCardMessageLoading;
      },
    oneCardSelect(card: any) {
      this.messageWriteWindow = true;
      this.$store.dispatch("cartItem/CARD_ADD", { ...card });
      this.selectedCard = { ...this.$store.state.cartItem.card };
    },
    changeCard() {
      this.messageWriteWindow = false;
    },
    selectedMessageTemplate(msgTemplate: any, cardIndex: any, msgIndex: any) {
      this.selectedMsgTemplates[cardIndex] = msgIndex;

      for (let i = 0; i < this.subscriptionTimePeriod; i++) {
        this.cardMessages[this.getMessageKeyName(i)] = msgTemplate.message;
      }

      this.cardMessages = Object.assign({}, this.cardMessages);
      this.$store.dispatch("cartItem/CARD_MESSAGES_ADD", {
        ...this.cardMessages,
      });
      this.messageValidation();
      this.remainingMsgChars(cardIndex, msgTemplate.message.length);
    },
    getMessageKeyName(i: any) {
      return `${i + 1}${this.getDateSuffix(i)} Message`;
    },
    messageValidation() {
      let disableContinue = false;
      Object.values(this.cardMessages).forEach((item) => {
        if (item === null || item === "") {
          disableContinue = true;
        }
      });
      if (disableContinue) {
        if (this.workflow == "SUBSCRIPTION") {
          this.$nuxt.$emit("disableContinueSubs", true);
        } else {
          this.$nuxt.$emit("disableContinue", true);
        }
      } else {
        if (this.workflow == "SUBSCRIPTION") {
          this.$nuxt.$emit("disableContinueSubs", false);
        } else {
          this.$nuxt.$emit("disableContinue", false);
        }
      }
    },
    handleMessage(message: any, messageIndex: number) {
      for (let i = 0; i < this.subscriptionTimePeriod; i++) {
        // Replace '"' for avoid bad Unicode escape sequence issue
        this.cardMessages[this.getMessageKeyName(i)] = (message)? `${message.replaceAll(/"/g, '\"\u200B'),message =message?.replace(/"/g, '')}`: message;
      }
      this.$store.dispatch("cartItem/CARD_MESSAGES_ADD", {
        ...this.cardMessages,
      });
      this.messageValidation();
      this.remainingMsgChars(messageIndex, message.length);
    },
    getDateSuffix(index: any) {
      return getDateSuffix(this.$i18n.locale, index + 1, true);
    },
    remainingMsgChars(index: number, msgLength: number) {
      this.remainingMsgCharacters[index] = this.msgMaxCharacters - msgLength;
    },
    getPrice(price: any) {
      return this.getPriceWithLocale(price);

    },
    async loadCards(){
      try {
        const region = this.getRegion().regionShortCode;
        const weekCode = this.selectWeekNumber(this.getDeliveryDate());
        let shopifyCards = {};
        if(this.workflow == 'NON_FLORAL'){
          shopifyCards = await invokeShopifyQuery(itemFilterWithActive("TR", CARD));
        }
        else{
          shopifyCards = await invokeShopifyQuery(itemFilterWithActive(region, CARD));
        }

        const activeCards = this.mapShopifyProducts(shopifyCards.data).filter(
          (card: { tags: string | string[] }) => {
            const tags = card.tags;
            return tags.includes("card") && tags.includes("active");
          }
        );

        this.cards = activeCards.filter((card: { tags: string | string[] }) => {
          const tags = card.tags;
          return (
            !tags.includes("exclusive-card") &&
            (tags.includes(weekCode) || tags.includes("card-ongoing")) &&
            !tags.includes("not-" + weekCode)
          );
        });
        this.exclusiveCards = activeCards.filter(
          (card: { tags: string | string[] }) => {
            const tags = card.tags;
            return tags.includes(weekCode) && tags.includes("exclusive-card");
          }
        );

      } catch (error) {
        throw new Error(`Oops something is not right!!! ${error}`);
      }

      // get card message templates from CMS
      try {
        const cardMessages = await butter(this.$config).content.retrieve(
          ["card_messages"],
          {
            locale: this.$i18n.locale,
            timeout: 10000
          }
        );
        let templatesData = cardMessages?.data.data.card_messages[0];
        if (JSON.stringify(templatesData) !== "{}") {
          this.msgTemplates = templatesData.message_templates;
          this.msgWriteWindowHeader = templatesData.header;
          this.msgMaxCharacters = templatesData.msg_max_chars;

          this.msgTemplates = this.msgTemplates.filter(item => item.title !== "Holidays");
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
};
